



























































import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import { Choice } from "@/types";

@Component({
  components: {}
})

/** グループ選択 */
export default class GroupSelector extends Vue {
  /** Prop */

  /** プルダウンID */
  @Prop({ default: "" }) private id!: string;

  /** プルダウンラベル名 */
  @Prop({ default: "" }) private label!: string;

  /** width */
  @Prop({ default: "40%" }) private width!: string;

  /** min-width */
  @Prop({ default: "266px" }) private minWidth!: string;

  /** 選択肢 */
  @Prop({ default: () => [] }) items!: Choice[];

  /** 選択結果 */
  @Prop() private value!: number;

  /** 変数 */

  /** 選択結果 */
  private get Value(): number {
    return this.value;
  }

  private set Value(newValue: number) {
    this.input(newValue);
  }

  /** Emit */

  /** 選択結果 */
  @Emit() private input(newValue: number) {
    return newValue;
  }
}
